import { config } from "./Conf";
/**
 * Enum with direct types used in checking arrays
 */
export var Direct;
(function (Direct) {
    Direct["VERTICAL"] = "VERTICAL";
    Direct["HORIZONTAL"] = "HORIZONTAL";
    Direct["DIAGONAL_LEFT"] = "DIAGONAL_LEFT";
    Direct["DIAGONAL_RIGHT"] = "DIAGONAL_RIGHT";
})(Direct || (Direct = {}));
/**
 * A class that inspects an array to find {@link Field | Fields} with {@link Ball | Balls} to destroy
 */
var BallSmasher = /** @class */ (function () {
    function BallSmasher() {
        this.toDestroy = [];
        this.minCountToDestroy = config.destroyCount;
    }
    /** @inheritdoc */
    BallSmasher.prototype.checkTab = function (fieldList) {
        this.toDestroy = [];
        this.checkingLoop(fieldList, Direct.VERTICAL);
        this.checkingLoop(fieldList, Direct.HORIZONTAL);
        this.checkingLoop(fieldList, Direct.DIAGONAL_LEFT);
        this.checkingLoop(fieldList, Direct.DIAGONAL_RIGHT);
        return Array.from(this.toDestroy);
    };
    /**
     * A method that checks a list of {@link Field | Fields} in a given {@link Direct | direction}
     * @param list Two-dimensional {@link Field} list
     * @param direct the {@link Direct | direction} of the check
     */
    BallSmasher.prototype.checkingLoop = function (list, direct) {
        var tempFields = [];
        var lastColor = '';
        if (direct == "VERTICAL" || direct == "HORIZONTAL") {
            for (var i = 0; i < list.length; i++) {
                for (var j = 0; j < list[i].length; j++) {
                    var field = direct == "VERTICAL" ? list[i][j] : list[j][i];
                    if (field.child) {
                        if (field.child.color != lastColor && field.child.color != 'all') {
                            if (lastColor != '') {
                                tempFields = this.clearTempFields(tempFields, false);
                            }
                            lastColor = field.child.color;
                        }
                        tempFields.push(field);
                    }
                    else {
                        tempFields = this.clearTempFields(tempFields);
                    }
                }
                tempFields = this.clearTempFields(tempFields);
                lastColor = '';
            }
        }
        else {
            for (var x = 0; x < (list.length * 2 - 1 - (2 * (this.minCountToDestroy - 1))); x++) {
                for (var i = direct == "DIAGONAL_LEFT" ? Math.abs(Math.min(0, list.length - 1 - (this.minCountToDestroy - 1) - x)) : list.length - 1 - Math.abs(Math.min(0, list.length - 1 - (this.minCountToDestroy - 1) - x)), j = Math.abs(Math.max(0, list.length - 1 - (this.minCountToDestroy - 1) - x)); direct == "DIAGONAL_LEFT" ? i < list.length && j < list.length : i >= 0 && j < list.length; direct == "DIAGONAL_LEFT" ? i++ : i--, j++) {
                    var field = list[i][j];
                    if (field.child) {
                        if (field.child.color != lastColor && field.child.color != 'all') {
                            if (lastColor != '') {
                                tempFields = this.clearTempFields(tempFields, false);
                            }
                            lastColor = field.child.color;
                        }
                        tempFields.push(field);
                    }
                    else {
                        tempFields = this.clearTempFields(tempFields);
                    }
                }
                tempFields = this.clearTempFields(tempFields);
                lastColor = '';
            }
        }
        this.removeDuplicats();
    };
    /**
     * A function that cleans the given array of {@link Field | Fields}. If there are enough {@link Field | Fields}, they are added to be destroyed
     * @param tempFields Array with Fields
     * @param blank The condition whether the function was called because of a color change (false) or because of an empty {@link Field} (true)
     * @returns Empty Array, or {@link Field} array with jokers
     */
    BallSmasher.prototype.clearTempFields = function (tempFields, blank) {
        var _a;
        if (blank === void 0) { blank = true; }
        if (tempFields.length >= this.minCountToDestroy) {
            (_a = this.toDestroy).push.apply(_a, tempFields);
        }
        var temp = [];
        if (blank == false) {
            for (var i = tempFields.length - 1; i >= 0; i--) {
                if (tempFields[i].child.color == 'all') {
                    temp.push(tempFields[i]);
                }
                else {
                    break;
                }
            }
        }
        return temp;
    };
    /**
     * A function for removing duplicates from the Array
     */
    BallSmasher.prototype.removeDuplicats = function () {
        this.toDestroy = this.toDestroy.filter(function (e, i, a) { if (a.indexOf(e) == i) {
            return e;
        } });
    };
    return BallSmasher;
}());
export { BallSmasher };
